import { RankData } from '../rank-card.service'

export const MockUseRecordType1: { view_infos: RankData[] } = {
  'view_infos': [
    {
      'name': '微信',
      'value': 18958
    },
    {
      'name': 'TIM',
      'value': 1877
    },
    {
      'name': 'QQ',
      'value': 1343
    }
  ]
}
